import { createSlice } from "@reduxjs/toolkit";

export const formStateSlice = createSlice({
    name: 'formState',
    initialState: {
        clientId: null,
        formType: null,
        activityItemId: null,
    },
    reducers: {
        setClientId: (state, action) => {
            state.clientId = action.payload;
        },
        setFormType: (state, action) => {
            state.formType = action.payload;
        },
        setActivityItemId: (state, action) => {
            state.activityItemId = action.payload;
        }
    },
});

export const { setClientId, setFormType, setActivityItemId } = formStateSlice.actions;
export default formStateSlice.reducer;
